import React from "react";
import TableMain from "../Common/table/TableMain";
import PointTableFilter from "../Common/table/PointTableFilter";
import { getLastPage } from "../../utils/getLastPage";
import { useTranslation } from "react-i18next";

const Approval = (props) => {
  const { t } = useTranslation();
  const reportHeader = [t("date"), t("amount"), t("payout_method"), t("status")]; 
  const headers = ["#","username", "email", "membership", "allocate sponsor","action"];
  const lastPage = getLastPage(props.itemsPerPage, props?.data?.totalCount);


 


   
  return (
    <div className="ewallet_table_section">
      <div className="ewallet_table_section_cnt">
        {/* <PointTableFilter
          setActiveTab={props.setActiveTab}
          activeTab={props.activeTab}
          headers={headers}
          reportHeader={reportHeader}
          data={props.data?.data}
          type={props.type}
          setCurrentPage={props.setCurrentPage}
          setDateRange={props.setDateRange}
        /> */}
        <div className="table-responsive min-hieght-table">
          <TableMain
            headers={headers}
            data={props?.data?.pendingData}
            startPage={1}
            currentPage={props.currentPage}
            totalPages={lastPage}
            type={props.type}
            itemsPerPage={props.itemsPerPage}
            setItemsPerPage={props.setItemsPerPage}
            setCurrentPage={props.setCurrentPage}
            setEpinSortOptions={props.setSortOptions}
            handleSelectChange={props.handleSelectChange}
            selectedValues={props.selectedValues}
            handlesubmit={props.handlesubmit}
          />
        </div>
      </div>
    </div>
  );
};

export default Approval;
